import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { getErrorId, getInfoId } from '@hivebrite/utils';
import { Box } from '@design-system/box';
import { CATEGORIES, FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { useTheme } from '@design-system/theme';
export const ADDITIONAL_INFORMATION_STATUS = Object.freeze({
    ALERT: 'ALERT',
    ERROR: 'ERROR',
    INFO: 'INFO',
    SUCCESS: 'SUCCESS',
});
export const AdditionalInformation = ({ children, iconColor, iconName, id, ml, mt = '2px', status = ADDITIONAL_INFORMATION_STATUS.ERROR, }) => {
    const theme = useTheme();
    const additionalInformationId = status === ADDITIONAL_INFORMATION_STATUS.ERROR ? getErrorId(id) : getInfoId(id);
    const ADDITIONAL_INFORMATION_STATUS_PROPS = {
        ALERT: {
            backgroundColor: theme.colors.mandarineLighter,
            iconColor: theme.colors.mandarine,
            iconName: 'triangle-exclamation',
        },
        ERROR: {
            backgroundColor: theme.colors.fireLighter,
            iconColor: theme.colors.fire,
            iconName: 'circle-exclamation',
        },
        INFO: {
            backgroundColor: theme.colors.floralWhite,
            iconColor: theme.colors.asphalt,
            iconName: 'circle-info',
        },
        SUCCESS: {
            backgroundColor: theme.colors.grassLighter,
            iconColor: theme.colors.grass,
            iconName: 'circle-check',
        },
    };
    const statusProps = ADDITIONAL_INFORMATION_STATUS_PROPS[status];
    const fontAwesomeIconName = iconName || statusProps.iconName;
    const fontAwesomeIconColor = iconColor
        ? theme.colors[iconColor] || iconColor
        : statusProps.iconColor;
    return (_jsx(Wrapper, { "data-testid": `ds-additional-information-${status.toLowerCase()}`, id: additionalInformationId, ml: ml, mt: mt, children: _jsxs(Background, { bg: statusProps.backgroundColor, "data-testid": "ds-additional-information-bg", children: [_jsx(Box, { flexShrink: 0, mt: 1, children: _jsx(FontAwesomeIcon, { color: fontAwesomeIconColor, height: "16px", iconName: fontAwesomeIconName, iconType: CATEGORIES.SOLID }) }), _jsx(Box, { color: "asphalt", font: "body-regular-asphalt", ml: 2, my: 1, children: children })] }) }));
};
const Wrapper = styled(Box).attrs(() => ({
    minHeight: '32px',
    py: 1,
})) `
  border-radius: 5px;
`;
const Background = styled(Box).attrs(() => ({
    px: 3,
    py: 1,
    width: '100%',
})) `
  border-radius: 5px;
`;
//# sourceMappingURL=AdditionalInformation.js.map